import { PATH_DELIMITER } from '@is24at/react-constants';
import { Http404, Http500 } from '@is24at/static-pages';
import {
  ROUTE_EXPOSE_BASE_PATH,
  ROUTE_HOME_BASE_PATH,
  ROUTE_RESULT_LIST_BASE_PATH,
  ROUTE_RESULT_LIST_BASE_AUSTRIA_PATH,
  IMMO_MAKLER_SLUG,
} from 'utils/enums';
import ResultList from './ResultList';
import Expose from './Expose';

export default [
  {
    path: ROUTE_HOME_BASE_PATH,
    component: ResultList,
    exact: true,
  },
  {
    path: ROUTE_RESULT_LIST_BASE_PATH,
    component: ResultList,
    exact: true,
  },
  {
    path: `${ROUTE_RESULT_LIST_BASE_PATH}${PATH_DELIMITER}${IMMO_MAKLER_SLUG}`,
    component: ResultList,
    exact: true,
  },
  {
    path: ROUTE_RESULT_LIST_BASE_AUSTRIA_PATH,
    component: ResultList,
    exact: true,
  },
  {
    path: `${ROUTE_RESULT_LIST_BASE_PATH}${PATH_DELIMITER}${IMMO_MAKLER_SLUG}${PATH_DELIMITER}:regionSlug${PATH_DELIMITER}:districtSlug?${PATH_DELIMITER}:citySlug?`,
    component: ResultList,
  },
  {
    path: `${ROUTE_EXPOSE_BASE_PATH}${PATH_DELIMITER}:titleSlug${PATH_DELIMITER}`,
    component: Expose,
    exact: true,
  },
  {
    path: `${ROUTE_EXPOSE_BASE_PATH}${PATH_DELIMITER}:titleSlug`,
    component: Expose,
    exact: true,
  },
  {
    path: `${ROUTE_EXPOSE_BASE_PATH}${PATH_DELIMITER}:cwid`,
    component: Expose,
  },
  {
    path: ROUTE_EXPOSE_BASE_PATH,
    component: ResultList,
    exact: true,
  },
  {
    path: '500',
    component: Http500,
  },
  {
    path: '*',
    component: Http404,
  },
];
